module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "justify-center": ""
    }
  }, [_c('v-card', {
    staticClass: "my-4",
    attrs: {
      "flat": "",
      "width": "250"
    }
  }, [_c('v-card-text', {
    staticClass: "text-center text-xs-center"
  }, [_c('v-icon', {
    staticClass: "mt-4",
    attrs: {
      "dark": "",
      "size": "76",
      "color": "green"
    }
  }, [_vm._v("\n        check_circle\n      ")]), _vm._v(" "), _c('h3', {
    staticClass: "subheading text-xs-center mb-4"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('title')) + "\n      ")]), _vm._v(" "), _c('h3', {
    staticClass: "overline text-center"
  }, [_vm._v(_vm._s(_vm.$t('subtitles.nextsteps')) + ":")]), _vm._v(" "), _c('v-btn', {
    staticClass: "mt-2",
    attrs: {
      "color": "primary",
      "outlined": "",
      "block": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit("send", _vm.statement)
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('buttons.send')) + "\n        "), _c('v-icon', {
    staticClass: "ml-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v("send")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "mt-2",
    attrs: {
      "href": _vm.statement.url,
      "target": "_blank",
      "outlined": "",
      "block": "",
      "small": "",
      "outline": ""
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('buttons.view')) + "\n        "), _c('v-icon', {
    staticClass: "ml-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v("open_in_new")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit("close")
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('buttons.done')) + "\n      ")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ecf79d18","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forms/Statement/Success.vue
// module id = 1544
// module chunks = 9